'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/monthAgo.js
// module id = 715
// module chunks = 0